export class AppDataEvent {
  code: string;
  name: string;
  tracked_event_type: string;
  event_type: string;
  constructor(
    event_name: string,
    code: string,
    tracked_event_type: string,
    event_type: string
  ) {
    this.code = code;
    this.name = event_name;
    this.tracked_event_type = tracked_event_type;
    this.event_type = event_type;
  }
}

export class AppData {
  name: string;
  credit_source: string;
  app_platform: string;
  tracking_vendor: string;
  events: AppDataEvent[];
  state: string;
  constructor(
    name: string,
    credit_source: string,
    data_type: string,
    tracking_vendor: string,
    events: AppDataEvent[],
    state: string
  ) {
    this.name = name;
    this.credit_source = credit_source;
    this.app_platform = data_type;
    this.tracking_vendor = tracking_vendor;
    this.events = events;
    this.state = state;
  }
}

export class LookAlike {
  name: string;
  first_party_data: number | null;
  state: string;
  constructor(name: string, first_party_data: number, state: string) {
    this.name = name;
    this.state = state;
    this.first_party_data = first_party_data;
  }
}

export interface TdspUploadData {
  name: string;
  description: string;
  available_to_all: true;
  user_segment_type: "segment_pixel" | "segment_upload";
  agencies: [];
  advertisers: [];
  agency_advertisers: [];
  state: "active";
  region?: string | null;
}

export interface TdspThirdPsegData {
  id: number;
  tdsp_id: string;
  name: string;
  cpm: string;
}

export interface Mappings {
  mapping_type: string;
  url_pattern: string;
  is_conversion_event: boolean;
  data_event_type: string;
  name: string;
}

export interface DynamicParameter {
  value: string;
  type: string;
}
export interface Pixel {
  name: string;
  state: string;
  mappings: Array<Mappings>;
  containsParam: boolean;
  dynamic_parameters: Array<DynamicParameter> | Array<any>;
}

export const mappingTypes = [
  { value: "custom", label: "All" },
  { value: "contains", label: "Contains" },
  { value: "exact", label: "Exact" },
  { value: "starts_with", label: "Starts With" },
  { value: "ends_with", label: "Ends With" },
];

export const dynamicParamterOptions = [
  "currency",
  "revenue",
  "order_id",
  "custom",
];

export const MAX_CUSTOM_PARAMS = 10;
